import React from "react";
import TableView from "../../components/TableView";
import { EntriesProvider } from "../../context/EntriesContext";
import { ClientAlertsProvider } from "../../context/administration/ClientAlertsContext";

export default function Search() {
    return (
        <ClientAlertsProvider>
            <EntriesProvider>
                <TableView />
            </EntriesProvider >
        </ClientAlertsProvider >
    );
};